var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusQueued(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.75C2.44922 0.75 0 3.2207 0 6.25C0 9.30078 2.44922 11.75 5.5 11.75C8.5293 11.75 11 9.30078 11 6.25C11 3.2207 8.5293 0.75 5.5 0.75ZM4.8125 4.875V7.625C4.8125 8.01172 4.49023 8.3125 4.125 8.3125C3.73828 8.3125 3.4375 8.01172 3.4375 7.625V4.875C3.4375 4.50977 3.73828 4.1875 4.10352 4.1875C4.44727 4.1875 4.8125 4.50977 4.8125 4.875ZM7.5625 4.875V7.625C7.5625 8.01172 7.24023 8.3125 6.875 8.3125C6.48828 8.3125 6.1875 8.01172 6.1875 7.625V4.875C6.1875 4.50977 6.48828 4.1875 6.85352 4.1875C7.19727 4.1875 7.5625 4.50977 7.5625 4.875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusQueued);
export default __webpack_public_path__ + "static/media/status-queued.c1a5e294ff3e8ed134781bbc07a0a9d7.svg";
export { ForwardRef as ReactComponent };